import { Injectable } from '@angular/core';

@Injectable()
export class DateExpiredService {
  isExpired(dateToCheck: any): boolean {
    // Convert dateToCheck to a Date object if it's not already
    const date = new Date(dateToCheck);

    if (isNaN(date.getTime())) {
      console.warn('il formato della data: ' + dateToCheck + ' non è valido');
      return false;
    }

    const currentDate = new Date();
    return date < currentDate;
  }
}
